import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import PropertyDetailHeader from './PropertyDetailHeader/PropertyDetailHeader';
import PropertyDetailBasicInfo from './PropertyDetailBasicInfo/PropertyDetailBasicInfo';
import PropertyDetailOverview from './PropertyDetailOverview/PropertyDetailOverview';
import PropertyDetailDemographics from './PropertyDetailDemographics/PropertyDetailDemographics';
import PropertyDetailAdditional from './PropertyDetailAdditional/PropertyDetailAdditional';
import PropertyDetailTransportation from './PropertyDetailTransportation/PropertyDetailTransportation';
import PropertyDetailUtilities from './PropertyDetailUtilities/PropertyDetailUtilities';
import PropertyDetailContact from './PropertyDetailContact/PropertyDetailContact';
import PropertyDetailMap from './PropertyDetailMap/PropertyDetailMap';
import PropertyDetailAreaInformation from './PropertyDetailAreaInformation/PropertyDetailAreaInformation';

import { storage } from '../../config';
import svgInline from '../SvgInline/SvgInline';
import { ViewerPrimaryColorUserStyle } from '../UserCustomization';

import closeIcon from '../../shared/assets/icon-close.svg';
import './PropertyDetail.css';

const components = {
  utilities: PropertyDetailUtilities,
  transportation: PropertyDetailTransportation,
  details: PropertyDetailAdditional,
  overview: PropertyDetailOverview,
  demographics: PropertyDetailDemographics,
};

const defaultComponentDisplayOrder = {
  overview: [
    'overview',
    'demographics',
  ],
  details: [
    'details',
    'transportation',
    'utilities',
  ],
  basicInfoKeys: [
    'address',
    'suite',
    'unit',
    'city',
    'state',
    'county',
    'buildingType',
    'availableSqft',
    'sizeSize',
    'acres',
    'salePrice',
    'pricingNote',
    'leaseRate',
    'leaseRateNote',
    'leaseTerms',
    'lastUpdated',
  ],
};

export class PropertyDetailComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showDetailsTab: false,
      selectedTabIdx: 0,
      loadingProperty: false,
      propertyName: '',
    };
  }

  async componentWillMount() {
    const {
      property,
      match: { params: { propertyId }, url },
      fetchProperty,
      organizationId,
      activePropertyTabs,
    } = this.props;

    if (!property || (property.id !== propertyId)) {
      const propertyRes = await fetchProperty(propertyId, organizationId);
      this.setPropertyName(propertyRes);
    }
    const activeTab = url.match(/details|state|region|county|community/g);
    let activeTabId = 0;
    if (activeTab && activeTab.length) {
      const tab = activeTab[0];
      activeTabId = activePropertyTabs.findIndex(t => t === tab);
    }
    if (activeTabId > 0) {
      this.handleSelectedTab(activeTabId);
    } else {
      this.handleSelectedTab(0);
    }
  }

  async componentWillReceiveProps(nextProps) {
    const {
      property: nextProperty,
      match: {
        params: {
          propertyId: nextPropertyId,
        },
      },
    } = nextProps;
    const {
      match: {
        params: {
          propertyId: currPropertyId,
        },
      },
      organizationId,
    } = this.props;
    if (!nextProperty || (nextPropertyId && nextPropertyId !== currPropertyId)) {
      const el = document.getElementById('property-detail-top');
      if (el) {
        el.scrollIntoView({ block: 'end' });
      }
      this.setState({ loadingProperty: true });
      const propertyRes = await this.props.fetchProperty(nextPropertyId, organizationId);
      this.setPropertyName(propertyRes);
      this.setState({ loadingProperty: false, selectedTabIdx: 0 });
    }
  }

  setPropertyName = property => {
    let propertyName = '';
    let suite = null;
    let unit = null;
    if (property.name) {
      propertyName = property.name;
    } else if (property.basicInfo && property.basicInfo.name) {
      propertyName = property.basicInfo.name;
    }

    if (property.basicInfo && property.basicInfo.location && property.basicInfo.location.suite) {
      suite = property.basicInfo.location.suite;
    }
    if (property.basicInfo && property.basicInfo.location && property.basicInfo.location.unit) {
      unit = property.basicInfo.location.unit;
    }
    if (suite || unit) {
      propertyName += ` Suite ${suite || unit}`;
    }
    propertyName = propertyName.trim().replaceAll(' ', '-');
    this.setState({ propertyName });
  }

  handleSelectedTab = id => {
    const { routeToSubTab, match: { params: { propertyId } }, activePropertyTabs } = this.props;
    this.setState({ selectedTabIdx: id });
    const activeTab = activePropertyTabs[id];
    routeToSubTab(propertyId, activeTab === 'overview' ? '' : `/${activeTab}`, encodeURIComponent(this.state.propertyName));
  }

  updateDetailsTab = shouldShow => {
    if (!this.state.showDetailsTab) {
      this.setState({ showDetailsTab: this.state.showDetailsTab || shouldShow });
    }
  }

  render() {
    const {
      isMobile,
      goToList,
      onCloseClick,
      type,
      property,
      organizationId,
      showShareModal,
      showSlideshow,
      showDownloadModal,
      showSpecialDownloadModal,
      showModal,
      handleModalOpen,
      onDemographicsClick,
      organizationContact,
      viewer,
      // overview,
      getAreas,
      // area,
      areasLoading,
      detailInfoToShow,
      activePropertyTabs,
    } = this.props;

    const { basicInfo: { location } = {} } = property;
    const { activeColor } = viewer;
    const singularType = type.slice(0, -1);
    const componentDisplayOrder = viewer.componentDisplayOrder || defaultComponentDisplayOrder;

    if (!property || !property.attachments) {
      return isMobile ? (
        <div className="detail-wrapper detail-wrapper--empty">
          <p>{`Please select a ${singularType} from the list`}</p>
          <p>
            <button type="button" className="btn" style={{ marginTop: 20 }} onClick={goToList}>View List</button>
          </p>
        </div>
      ) : (
        <div>
          <img
            alt="loading gif"
            src={`${storage.distPath}/loading.gif`}
          />
        </div>
      );
    }

    const fallback = Array.isArray(property.attachments) ? property.attachments[0] : { images: {} };
    const attachmentImages = property.attachments && property.attachments.images
      ? property.attachments
      : fallback;
    const { dateModified = 'Unavailable' } = property;

    const overviewSections = componentDisplayOrder.overview.map((key, index) => {
      const OverviewComponent = components[key];
      return <OverviewComponent key={index} {...this.props} />;
    });

    const detailSections = componentDisplayOrder.details.map((key, index) => {
      const DetailComponent = components[key];
      return (<DetailComponent
        key={index}
        updateDetailsTab={this.updateDetailsTab}
        {...this.props}
      />);
    });

    const detailTabClasses = this.state.showDetailsTab ? 'react-tabs__tab tab-detail' : 'react-tabs__tab tab-detail hide-details-tab';
    const noScrollStyle = this.state.loadingProperty ? { overflow: 'unset' } : {};

    return (
      <div className="property-detail detail-wrapper" style={noScrollStyle}>
        <div id="property-detail-top" />
        {this.state.loadingProperty &&
          <div className="loading-overlay">
            <img
              id="loading-overlay-gif"
              alt="loading gif"
              src={`${storage.distPath}/loading.gif`}
            />
          </div>
        }
        {!isMobile && !this.state.loadingProperty && (
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <a
              className="close-btn"
              onClick={() => { onCloseClick(); }}
              tabIndex="0"
            >
              {svgInline(closeIcon)}
              CLOSE
            </a>
          </ViewerPrimaryColorUserStyle>
        )}
        <div className="property-detail">
          <PropertyDetailHeader
            ref={detailHeader => { this.detailHeader = detailHeader; }}
            basicInfo={property.basicInfo}
            id={property._id}
            organizationId={organizationId}
            showSlideshow={showSlideshow}
            property={property}
            type={type}
            showShareModal={showShareModal}
            handleModalOpen={handleModalOpen}
            onDemographicsClick={onDemographicsClick}
            viewer={viewer}
          />
          <div className="detail-content">
            <div className="detail-col-1">
              <PropertyDetailBasicInfo
                id={property._id}
                showSlideshow={showSlideshow}
                type={type}
                org={property.org}
                basicInfo={property.basicInfo}
                contacts={property.contacts}
                additionalDetails={property.additionalDetails}
                attach={attachmentImages}
                dateModified={dateModified}
                viewer={viewer}
                displayKeys={componentDisplayOrder.basicInfoKeys}
              />
            </div>
            <div className="detail-col-2">
              <div className="property-tab-header-labels">
                <ViewerPrimaryColorUserStyle domStyle="color">
                  <h4>Property Profile</h4>
                </ViewerPrimaryColorUserStyle>
                {activePropertyTabs.length > 2 &&
                <ViewerPrimaryColorUserStyle domStyle="color">
                  <h4>Area Profile</h4>
                </ViewerPrimaryColorUserStyle>
              }
              </div>
              <Tabs
                selectedIndex={this.state.selectedTabIdx}
                onSelect={index => this.handleSelectedTab(index)}
              >
                <TabList style={{ borderColor: activeColor }}>
                  <Tab><span style={{ borderColor: activeColor }}>Overview</span></Tab>
                  <Tab className={detailTabClasses}>
                    <span style={{ borderColor: activeColor }}>Details</span>
                  </Tab>
                  {activePropertyTabs.includes('state') &&
                    <Tab className="react-tabs__tab tab-state"><span style={{ borderColor: activeColor }}>State</span></Tab>
                  }
                  {activePropertyTabs.includes('region') &&
                    <Tab className="react-tabs__tab tab-region"><span style={{ borderColor: activeColor }}>Region</span></Tab>
                  }
                  {activePropertyTabs.includes('county') &&
                    <Tab className="react-tabs__tab tab-county"><span style={{ borderColor: activeColor }}>County</span></Tab>
                  }
                  {activePropertyTabs.includes('community') &&
                    <Tab className="react-tabs__tab tab-community"><span style={{ borderColor: activeColor }}>Community</span></Tab>
                  }
                </TabList>

                <TabPanel>
                  <div className="detail-overview animate__animated animate__fadeIn">
                    { overviewSections }
                    <PropertyDetailMap
                      property={property}
                      type={type}
                      viewer={viewer}
                    />
                  </div>
                </TabPanel>

                <TabPanel forceRender>
                  <div className="detail-details animate__animated animate__fadeIn">
                    { detailSections }
                  </div>
                </TabPanel>

                {activePropertyTabs.includes('state') &&
                <TabPanel>
                  <PropertyDetailAreaInformation
                    layer={'states'}
                    organizationId={organizationId}
                    organizationContact={organizationContact}
                    viewer={viewer}
                    // overview={overview}
                    getAreas={getAreas}
                    location={location}
                    // area={area}
                    areasLoading={areasLoading}
                    detailInfoToShow={detailInfoToShow}
                    handleModalClick={onDemographicsClick}
                    showShareModal={showShareModal}
                    showSlideshow={showSlideshow}
                    showDownloadModal={showDownloadModal}
                    showSpecialDownloadModal={showSpecialDownloadModal}
                    showModal={showModal}
                    loadingProperty={this.state.loadingProperty}
                    type={type}
                  />
                </TabPanel>
                }

                {activePropertyTabs.includes('region') &&
                <TabPanel>
                  <PropertyDetailAreaInformation
                    layer={'regions'}
                    organizationId={organizationId}
                    organizationContact={organizationContact}
                    viewer={viewer}
                    // overview={overview}
                    getAreas={getAreas}
                    location={location}
                    // area={area}
                    areasLoading={areasLoading}
                    detailInfoToShow={detailInfoToShow}
                    handleModalClick={onDemographicsClick}
                    showShareModal={showShareModal}
                    showSlideshow={showSlideshow}
                    showDownloadModal={showDownloadModal}
                    showSpecialDownloadModal={showSpecialDownloadModal}
                    showModal={showModal}
                    loadingProperty={this.state.loadingProperty}
                    type={type}
                  />
                </TabPanel>
                }

                {activePropertyTabs.includes('county') &&
                <TabPanel>
                  <PropertyDetailAreaInformation
                    layer={'counties'}
                    organizationId={organizationId}
                    organizationContact={organizationContact}
                    viewer={viewer}
                    // overview={overview}
                    getAreas={getAreas}
                    location={location}
                    // area={area}
                    areasLoading={areasLoading}
                    detailInfoToShow={detailInfoToShow}
                    handleModalClick={onDemographicsClick}
                    showShareModal={showShareModal}
                    showSlideshow={showSlideshow}
                    showDownloadModal={showDownloadModal}
                    showSpecialDownloadModal={showSpecialDownloadModal}
                    showModal={showModal}
                    loadingProperty={this.state.loadingProperty}
                    type={type}
                  />
                </TabPanel>
                }

                {activePropertyTabs.includes('community') &&
                <TabPanel>
                  <PropertyDetailAreaInformation
                    layer={'communities'}
                    organizationId={organizationId}
                    organizationContact={organizationContact}
                    viewer={viewer}
                    // overview={overview}
                    getAreas={getAreas}
                    location={location}
                    // area={area}
                    areasLoading={areasLoading}
                    detailInfoToShow={detailInfoToShow}
                    handleModalClick={onDemographicsClick}
                    showShareModal={showShareModal}
                    showSlideshow={showSlideshow}
                    showDownloadModal={showDownloadModal}
                    showSpecialDownloadModal={showSpecialDownloadModal}
                    showModal={showModal}
                    loadingProperty={this.state.loadingProperty}
                    type={type}
                  />
                </TabPanel>
                }
              </Tabs>
            </div>
          </div>
          <PropertyDetailContact
            className="detail-footer"
            contact={organizationContact}
            viewer={viewer}
          />
        </div>
      </div>
    );
  }
}

// ToDo: Create a building proptype and import
PropertyDetailComponent.propTypes = {
  type: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  goToList: PropTypes.func,
  onCloseClick: PropTypes.func.isRequired,
  organizationId: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      propertyId: PropTypes.string,
      subTab: PropTypes.string,
    }),
  }),
  fetchProperty: PropTypes.func.isRequired,
  routeToSubTab: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  showShareModal: PropTypes.func.isRequired,
  showSlideshow: PropTypes.func,
  onDemographicsClick: PropTypes.func.isRequired,
  showDownloadModal: PropTypes.func,
  showSpecialDownloadModal: PropTypes.func,
  showModal: PropTypes.func,
  organizationContact: PropTypes.object,
  viewer: PropTypes.object.isRequired,
  // overview: PropTypes.object,
  getAreas: PropTypes.func,
  // area: PropTypes.shape({
  //   name: PropTypes.string,
  //   polygon: PropTypes.object,
  // }),
  areasLoading: PropTypes.bool,
  detailInfoToShow: PropTypes.arrayOf(PropTypes.string),
  activePropertyTabs: PropTypes.arrayOf(PropTypes.string),
};

export default PropertyDetailComponent;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetail.js